import React, { useState, useEffect, useContext } from 'react'
import DatePicker from "react-datepicker";
import { AppContext } from "../../AppContext";
import UserSelectBox from "../common/controls/UserSelectBox";


const PoliticalFormDonateDefault = (props)=> {

    const [appContext, setAppContext] = useContext(AppContext);

    const handleNumberFieldDecimalChange = (e) => {
        if (/^\d+\.?\d{0,2}$/.test(e.target.value) || e.target.value === "") {
          props.handleChange(e);
        }
      };

    return (

        <div className="form-items mt-4">
                    
            <div className="form-columns">

                <div className="form-column">
                
                    <div className="form-item">
                        <label className={`form-item-label required ${props.validation.contribDate ? "" : "warning"}`} htmlFor="contribDate">Donation or Planned For Date :</label>
                        <div className="form-item-value">
                            <DatePicker selected={props.data.contribDate} onChange={p=>props.handleDateChange(p,"contribDate")}/>
                        </div>
                    </div>

                    <div className="form-item">
                        <label className={`form-item-label required ${props.validation.description ? "" : "warning" }`} htmlFor="description">Description :</label>
                        <input className="form-item-value" type="text" id="description" name="description" maxLength="500" value={props.data.description} onChange={props.handleChange}/>
                    </div>
                    
                    <div className="form-item">
                        <label className={`form-item-label required ${props.validation.contribAmount ? "" : "warning" }`} htmlFor="contribAmount">Contribution Amount :</label>
                        <input className="form-item-value" type="text" id="contribAmount" name="contribAmount" value={props.data.contribAmount} onChange={handleNumberFieldDecimalChange}/>
                    </div>

                    <div className="form-item">
                        <label className={`form-item-label required ${props.validation.currency ? "" : "warning" }`} htmlFor="currency">Currency :</label>
                        <input className="form-item-value" type="text" id="currency" name="currency" maxLength="50" value={props.data.currency} onChange={props.handleChange}/>
                    </div>

                </div>

                <div className="form-column">
                  <div className="form-item">
                      <label className="form-item-label" htmlFor="attachment">Attachment Document :</label>
                      <div className="form-item-value placeholder">
                          <input type="file" name="attachment" id="attachment" onChange={props.handleChange}/>
                      </div>
                    </div>


                    <div className="form-item">
                        {appContext.user.submitOnBehalf && props.editorMode === 'NEW' &&
                            <UserSelectBox label='Submit On Behalf of (Optional) : ' styleClass='mt-3rem' onSelected={props.handleChange} name='submittedFor' value={() => { return props.data.submittedFor ? { value: props.data.submittedFor, label: props.data.submittedForLabel } : null }} />
                        }
                    </div>


                </div>
            </div>
        </div>

    );
}

export default PoliticalFormDonateDefault;

